import { useState } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../../types/rootState'
import { defineMessages, useIntl } from 'react-intl'
import { AsyncPanel, Panel } from '../../../Components'
import { PmiEstimatedDmStep } from './PmiEstimatedDmStep'
import { PmiEstimatedInputStep } from './PmiEstimatedInputStep'
import { Box, Text, Heading } from '@homebot/shared-ui-swashbuckle'
import { PmiEstimatedInitialStep } from './PmiEstimatedInitialStep'
import { PmiEstimatedMortgagesStep } from './PmiEstimatedMortgagesStep'

import styles from './PmiEstimatedModule.module.scss'

export const MSG = defineMessages({
  tuneHomebot: {
    id: 'Pmi.Estimated.tuneYourHomebot',
    defaultMessage: 'Tune your homebot',
  },
  doYouHavePmi: {
    id: 'Pmi.Estimated.doYouHavePmi',
    defaultMessage: 'Do you have PMI?',
  },
  estimating: {
    id: 'Pmi.Estimated.bodyText',
    defaultMessage:
      'We estimate that you might have private mortgage insurance (PMI).',
  },
})

export enum PmiStepEnum {
  DmStep = 'DmStep',
  InitialStep = 'InitialStep',
  InputStep = 'InputStep',
  MortgageStep = 'MortgageStep',
}

export const PmiEstimatedModule = () => {
  const intl = useIntl()
  const [inProgress, setInProgress] = useState(false)
  const [step, setStep] = useState(PmiStepEnum.InitialStep)
  const showPmiEstimatedModule = useSelector<RootState, boolean | null>(
    state => state.pmi.showPmiEstimatedModule
  )

  return (
    <AsyncPanel
      className={styles.panel}
      dataQa='pmi-estimated-module'
      show={showPmiEstimatedModule || inProgress}
    >
      <Heading
        as='h3'
        size='xs'
        textAlign='left'
        variant='eyebrow'
        color='text.brand'
      >
        {intl.formatMessage(MSG.tuneHomebot)}
      </Heading>
      <Panel.Heading textAlign='left' fontWeight='semibold'>
        {intl.formatMessage(MSG.doYouHavePmi)}
      </Panel.Heading>
      <Text>{intl.formatMessage(MSG.estimating)}</Text>
      <Box marginTop='spacing-800'>
        {step === PmiStepEnum.DmStep && (
          <PmiEstimatedDmStep setStep={setStep} />
        )}
        {step === PmiStepEnum.MortgageStep && (
          <PmiEstimatedMortgagesStep setInProgress={setInProgress} />
        )}
        {step === PmiStepEnum.InputStep && (
          <PmiEstimatedInputStep
            setStep={setStep}
            setInProgress={setInProgress}
          />
        )}
        {step === PmiStepEnum.InitialStep && (
          <PmiEstimatedInitialStep
            setStep={setStep}
            setInProgress={setInProgress}
          />
        )}
      </Box>
    </AsyncPanel>
  )
}
